module.exports = __webpack_public_path__ + "static/img/underReview.47806a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/underReview.svg
// module id = 0hov
// module chunks = 1 2